import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { compose, hoistStatics, withState, lifecycle, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';

import AddNew from './AddNew';
import fh from '../../../../../helpers/form.helper';
import TicketService from '../../../../../services/ticket.service';

function htmlEncode(str){
  return String(str).replace(/[^\w. ]/gi, function(c){
    return '&#'+c.charCodeAt(0)+';';
  });
}

const postNewTicket = props => async (e) => {
  e.preventDefault();
  const {
    goToPage,
    isSubmitting,
    setIsSubmitting,
    addedArt,
    setAddedArt,
    mulTempFiles,
    setErrors,
    history,
  } = props;
  if (isSubmitting) return;
  await setIsSubmitting(true);
  await setAddedArt({ ...addedArt, newItem: '' });
  const files = mulTempFiles.ticket &&
  mulTempFiles.ticket.length ?
    mulTempFiles.ticket.map(ticket => ticket.id) : [];
  const resp = await TicketService.update({ ...addedArt, files, message: htmlEncode(addedArt.message) });
  if (resp.model) {
    await setIsSubmitting(false);
    await goToPage(0);
    history.push(`/ticket/${resp.model.id}`);
    toast.success(props.t('Ticket added'));
  } else {
    await setIsSubmitting(false);
    setErrors(resp.errors);
  }
  return resp;
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
});

const addItem = props => ({ target }) => {
  const { addedArt, setAddedArt } = props;
  const { name, value } = target;
  setAddedArt({ ...addedArt, [name]: value });
};

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('formData', 'setFormData', {}),
  withState('addedArt', 'setAddedArt', {}),
  withState('errors', 'setErrors', {}),
  lifecycle({
    async componentDidMount() {
      this.props.setIsLoading(false);
    },
  }),
  withHandlers({
    addItem,
    postNewTicket,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(AddNew));



// WEBPACK FOOTER //
// ./src/views/modules/ticket/ticket/addNew/index.js